import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CommonService,
  CONSTANT,
  LoaderService,
  ObservableService,
  OrderService,
} from '@bst-frontend/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bst-frontend-confirm-payment-modal',
  templateUrl: './confirm-payment-modal.component.html',
  styleUrls: ['./confirm-payment-modal.component.css'],
})
export class ConfirmPaymentModalComponent {
  dispatchForm!: FormGroup;
  @Input() orderData: any;
  constructor(
    private activeModal: NgbActiveModal,
    private loader: LoaderService,
    private orderService: OrderService,
    private observableService: ObservableService,
    public commonService: CommonService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.dispatchForm = this.fb.group({
      // keep these if you need LR details, can be wired to template later
      amount: [this.orderData?.totals?.amount, Validators.required],
      amountDiff: ['', Validators.required],
      notes: [''],
    });
  }

  async onSubmit() {
    if (this.dispatchForm.invalid) {
      this.dispatchForm.markAllAsTouched();
      return;
    }

    const payload: any = {
      amount: this.dispatchForm.value.amount,
      amountDiff: this.dispatchForm.value.amountDiff,
      notes: this.dispatchForm.value.notes,
    };

    this.loader.show();
    try {
      await this.orderService
        .updateOrderStatus(
          CONSTANT.orderStatus['paid'],
          this.orderData._id,
          payload
        )
        .toPromise();
      this.observableService.send({ refresh: true });
      // this.loader.hide();
    } catch (error) {
      console.log('Error', error);
    }

    this.activeModal.close({ status: 'saved' });
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
